import classes from './ChatWidget.module.scss'
import FeatureModal from './FeatureModal'
import { CommissionMode } from './types'

interface Props {
  onClose: () => void
  onSelect: (mode: CommissionMode, label: string) => void
}

const CHOICES: { mode: CommissionMode; label: string; description: string }[] = [
  {
    mode: 'best',
    label: 'En uygun oranlar',
    description: 'Her taksit için en düşük komisyonlu bankayı listeler.',
  },
  {
    mode: 'all',
    label: 'Tüm oranlar',
    description: 'Tüm bankaların oranlarını taksit taksit gruplayarak gösterir.',
  },
]

/**
 * Komisyon oranları görünüm seçici. Diğer özellik modallarının aksine sonucu kendi içinde
 * göstermez: seçimi sohbete devreder, kart bot balonunun altında doğar. Bu yüzden kendi
 * yükleniyor/hata durumu yoktur — hatayı sohbetin kendi hata balonu gösterir.
 */
export default function CommissionRatesModal({ onClose, onSelect }: Props) {
  return (
    <FeatureModal
      titleId='commission-rates-modal-title'
      title='Komisyon Oranları'
      description='Kredi kartı komisyon oranlarını nasıl görmek istersiniz?'
      onClose={onClose}
    >
      <div className={classes.modalChoices}>
        {CHOICES.map((choice, index) => (
          <button
            key={choice.mode}
            type='button'
            className={classes.modalChoice}
            data-modal-initial-focus={index === 0 || undefined}
            onClick={() => onSelect(choice.mode, choice.label)}
          >
            <span className={classes.modalChoiceLabel}>{choice.label}</span>
            <span className={classes.modalChoiceDescription}>{choice.description}</span>
          </button>
        ))}
      </div>
    </FeatureModal>
  )
}
